export default __webpack_public_path__ + "static/media/Provider_emp_type.9c0f608d.svg";